import { render, staticRenderFns } from "./AfterAuth.vue?vue&type=template&id=2a2ccc75"
import script from "./AfterAuth.vue?vue&type=script&lang=js"
export * from "./AfterAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports